// src/components/chatbot/ChatSuggestions.tsx
import React from 'react';
import { Button } from '@/components/ui/button';
import { SuggestionItem } from './types';

type ChatSuggestionsProps = {
  suggestions: SuggestionItem[];
  onSuggestionClick: (suggestion: SuggestionItem) => void;
};

const ChatSuggestions: React.FC<ChatSuggestionsProps> = ({
  suggestions,
  onSuggestionClick,
}) => {
  return (
    <div className="flex flex-wrap gap-2">
      {suggestions.map((suggestion) => (
        <Button
          key={suggestion.id}
          variant="outline"
          size="sm"
          className="text-xs py-1 h-auto"
          onClick={() => onSuggestionClick(suggestion)}
        >
          {suggestion.text}
        </Button>
      ))}
    </div>
  );
};

export default ChatSuggestions;